import { render, staticRenderFns } from "./ReplyChat.vue?vue&type=template&id=b0d44d38&scoped=true&"
import script from "./ReplyChat.vue?vue&type=script&lang=js&"
export * from "./ReplyChat.vue?vue&type=script&lang=js&"
import style0 from "./ReplyChat.vue?vue&type=style&index=0&id=b0d44d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d44d38",
  null
  
)

export default component.exports